module.exports = "#available-emp .ibox-content{\n        max-height: 295px;\n        overflow-y: auto;\n    }"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/maindashboard/available-employees/available-employees.component.css
// module id = ./src/app/modules/dashboard/components/maindashboard/available-employees/available-employees.component.css
// module chunks = main